export default {
    MolegameTitle: "打地鼠-游戏设置",
    gameTitle: "打地鼠游戏",
    topicLabel: "主题",
    correctItems: "答对项目",
    correctItemsPlaceholder: "输入正确词汇，可用换行或逗号(,)分隔，按下Enter添加项目",
    errorItems: "错误项目",
    errorItemsPlaceholder: "输入错误词汇，可用换行或逗号(,)分隔，按下Enter添加项目",
    gameDuration: "游戏时长",
    moleSpeed: "地鼠停留时间",
    speedSlow: "长时间 (2.5秒)",
    speedMedium: "中等 (2秒)",
    speedFast: "短时间 (1.5秒)",
    speedVeryFast: "极短 (1秒)",
    second: "秒",
    saveSettings: "保存设置",
    startGame: "开始游戏",
    pauseGame: "暂停游戏",
    resumeGame: "继续游戏",
    gameOver: "游戏结束",
    leftSide: "左方",
    rightSide: "右方",
    leftWins: "左方获胜！",
    rightWins: "右方获胜！",
    tie: "平局！",
    playAgain: "再玩一次",
    wordExists: "词汇已存在，无需重复加入",
    maxVocabulary: "正确词汇已达最大值，请删减词汇再加入",
    maxErrorVocabulary: "错误词汇已达最大值，请删减词汇再加入",
    topic: "主题",
    inputTopic: "请输入主题",
    backgroundSetting: "背景设置",
    ocean: "海洋",
    desert: "沙漠",
    forest: "森林",
    
    // 游戏结束画面新增字符串
    win: "胜利",
    items: "个",
    wrongItems: "答对题目",
    maxCombo: "最高连击",
    showAnswers: "A",
    gamePaused: "活动暂停",
    referenceAnswers: "参考答案",
    clearData: "清除数据",
    sendSuccess: "游戏资料已成功推送！",
    sendCooldown: "已按发布送出，请等候1分钟才可再操作",
    pushSuccess: "游戏已成功推送到 HiTeach！",
    pushFailed: "推送失败：{message}",
    configLoadSuccess: "成功加载游戏配置",
    configLoadFailed: "加载失败（使用示例配置）",
    unsubmittedWarning: "发现输入框中尚有未按下Enter 的词汇，请确认后再保存!",
    tokenRefreshing: "正在刷新授权信息，请稍后再试...",
    smallScreenWarning: "本游戏为桌面版界面，建议于计算机平板使用，且最低屏幕宽度需求为 1200px*800px",
    currentRank: "当前排名",
    totalParticipants: "总参与人次",
}